
import { defineComponent } from 'vue';


export default defineComponent({
  name: 'JoinAgree',
  data() {
    return {
      "check_agree": false,
      "is_modal_open" : false,
    }
  },
  components: {

  },
  methods: {
    go_join() {
      if (this.check_agree == false) {
        this.openModal();
        return;
      }
      this.$router.push("/EmailAuth");
      

    },
    closeModal(){
      this.is_modal_open = false;
    },
    openModal(){
      this.is_modal_open = true;
    }

  },
});
